import { render, staticRenderFns } from "./overlap_correction_icon_btn.vue?vue&type=template&id=ff2b9558&scoped=true&"
import script from "./overlap_correction_icon_btn.vue?vue&type=script&lang=js&"
export * from "./overlap_correction_icon_btn.vue?vue&type=script&lang=js&"
import style0 from "./overlap_correction_icon_btn.vue?vue&type=style&index=0&id=ff2b9558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2b9558",
  null
  
)

export default component.exports